import React, { useMemo, useContext } from 'react';
import { IntlProvider } from 'react-intl';

import { useExtendedLogger } from '../Logger';

import { Context as LocaleContext } from './LocaleProvider';
import useTranslations from './useTranslations';
import { LOGGER_NAME } from './constants';

import type { TTranslationContext } from './types';

const Context = React.createContext<TTranslationContext | null>(null);

function Provider({
  children,
  localeBaseUrl,
  loader = <></>,
}: {
  children: React.ReactNode;
  localeBaseUrl?: string;
  loader?: React.ReactElement;
}) {
  const log = useExtendedLogger(LOGGER_NAME);

  const { currentLanguage } = useContext(LocaleContext);

  const { translations, loading, failed } = useTranslations(currentLanguage, localeBaseUrl);

  const context = useMemo(
    () => ({
      loading,
      failed,
    }),
    [failed, loading]
  );

  log('adding translation provider with context %o', context);

  return (
    <Context.Provider value={context}>
      <IntlProvider locale={currentLanguage} messages={translations}>
        {loading ? loader : children}
      </IntlProvider>
    </Context.Provider>
  );
}

export { Context, Provider };
